import { useInstance } from '../support/ioc/useInstance';
import { ITriggerPaywallSource, PaywallDialogViewModel } from './PaywallDialogViewModel.tsx';
import { WindyMapModalState } from '../weather/windy/WindyMapModalState.tsx';
import { HistoryViewModel } from '../app/HistoryViewModel.ts';
import { useEffect } from 'react';
import { OperatorState } from '../profile/OperatorState.ts';
import { IPaymentTerm } from './revenue-cat/RevenueCatModel.ts';

export const PaywallTriggerHandler: React.FC = () => {

    const history = useInstance(HistoryViewModel);
    const paywall = useInstance(PaywallDialogViewModel);
    const windyModal = useInstance(WindyMapModalState);
    const operator = useInstance(OperatorState);

    useEffect(() => {

        // if guest triggers paywall, they are sent to login with these query params in the returnTo url
        const [paywallTrigger, paywallTerm] = history.popSearchParams('paywallTrigger', 'paywallTerm') as [ITriggerPaywallSource, IPaymentTerm];

        if (paywallTrigger) {

            operator.skipSetupOperatorOnce();

            if (paywallTrigger === 'windy') {
                // windy is a special case, we want windy modal open after paywall
                windyModal.resumePaywall({ paymentTerm: paywallTerm });

            } else {
                paywall.resume({ paymentTerm: paywallTerm });
            }
        }

    }, [history, paywall, windyModal, operator]);

    return null;
};
